// extracted by mini-css-extract-plugin
module.exports = {"error":"error__3JPm8","icon":"icon__1GVGr","tooltip":"tooltip__1i21N"};